import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DamageCase, DamageDocument, CarBrand, CarType, Employee, Importer, Insurance, JobType, Receiver, DamageType, DamageArea, Damage, DamageImage, Feed} from '../../../models/models';
import {DamageDocumentTypeLabels, DamageInternalState, DamageInternalStateLabels} from 'src/app/models/enums';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {CheckService} from '../../../services/check.service';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {MatDatepicker} from '@angular/material/datepicker';
import {DatePipe} from '@angular/common';
import {FormControl, UntypedFormControl} from '@angular/forms';
import {forkJoin, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as _moment from 'moment';
import Swal from 'sweetalert2';

const moment = _moment;

export const CustomFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};
export class Event {
  isUserInput: boolean;
  target: HTMLInputElement;
}

@Component({
  selector: 'app-damage-administration-case.component',
  templateUrl: './damage-administration-case.component.html',
  styleUrls: ['./damage-administration-case.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: CustomFormats
    },
    [DatePipe]
  ],
})
export class DamageAdministrationCase implements OnInit {

  @ViewChild('damageDateInput', {static: true}) damageDateInput: ElementRef;
  @ViewChild('caseEndFocus', {static: true}) caseEndDateInput: ElementRef;
  @ViewChild('reimbursementFocus', {static: true}) reimbursementDateInput: ElementRef;
  @ViewChild('searchElement', {static: true}) searchElement: ElementRef;
  @ViewChild('caseId', {static: true}) caseId: ElementRef;
  @ViewChild('fileDropRef') fileDropEl: ElementRef;

  public firstTimeLoading = true;
  public translation: Translation;

  /* Dates & Times*/
  public date = new UntypedFormControl(moment());
  public tempDamageDate: Date;
  public tempCaseEndDate: Date;
  public tempReimbursementDate: Date;
  public maxDate: Date = new Date();
  public times: string[] = [];

  /* Selects */
  public caseIds: number[] = [];
  public caseIdControl = new UntypedFormControl();
  public filteredCaseIds: Observable<number[]>;
  public insuranceControl = new FormControl<Insurance | null>(null);
  public insurances: Insurance[] = [];
  public filteredInsurances!: Observable<Insurance[]>;
  public jobTypes: JobType[] = [];
  public jobTypeControl = new FormControl<JobType | null>(null);
  public filteredJobTypes: Observable<JobType[]>;
  public employees: Employee[] = [];
  public employeeControl = new FormControl<Employee | null>(null);
  public filteredEmployees: Observable<Employee[]>;
  public senders: Receiver[] = [];
  public senderControl = new FormControl<Receiver | null>(null);
  public filteredSenders: Observable<Receiver[]>;
  public receivers: Receiver[] = [];
  public receiverControl = new FormControl<Receiver | null>(null);
  public filteredReceivers: Observable<Receiver[]>;
  public workshops: Receiver[] = [];
  public workshopControl = new FormControl<Receiver | null>(null);
  public filteredWorkshops: Observable<Receiver[]>;
  public brands: CarBrand[] = [];
  public brandControl = new FormControl<CarBrand | null>(null);
  public filteredBrands: Observable<CarBrand[]>;
  public importers: Importer[] = [];
  public importerControl = new FormControl<Importer | null>(null);
  public filteredImporters: Observable<Importer[]>;
  public carTypes: CarType[] = [];
  public carTypeControl = new FormControl<CarType | null>(null);
  public filteredCarTypes: Observable<CarType[]>;
  public damageTypes: DamageType[] = [];
  public damageTypeControl = new FormControl<DamageType | null>(null);
  public filteredDamageTypes: Observable<DamageType[]>;
  public damageAreas: DamageArea[] = [];
  public damageAreaControl = new FormControl<DamageArea | null>(null);
  public filteredDamageAreas: Observable<DamageArea[]>;

  public readonly documentTypes = Object.entries(DamageDocumentTypeLabels).map(([key, label]) => ({ value: key, label }));
  public readonly states = Object.entries(DamageInternalStateLabels).map(([key, label]) => ({ value: Number(key) as DamageInternalState, label}));

  public damageCase = new DamageCase();
  public damageInEdit = new Damage();
  public documentInEdit = new DamageDocument();
  public userName = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
  public feedHtmlString = '';
  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private datepipe: DatePipe,
    private route: ActivatedRoute,
  ) { }

  /* Init */

  async ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(8);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.loadTimePicker();
    this.getAllCoreData();
  }

  public loadTimePicker() {
    const quarterHours = ['00', '15', '30', '45'];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 4; j++) {
        let time = '';
        if (i < 10) {
          time = '0' + i + ':' + quarterHours[j];
        } else {
          time = i + ':' + quarterHours[j];
        }
        this.times.push(time);
      }
      this.damageCase.DamageTime = this.times[0];
    }
  }

  public getAllCoreData() {
    this.damageCase.Damages = [];
    this.damageCase.DamageDocuments = [];
    this.damageCase.Feeds = [];
    const caseIdList = this.damageAdministrationService.getDamageCaseIds();
    const insuranceList = this.damageAdministrationService.getInsurances();
    const jobTypeList = this.damageAdministrationService.getJobTypes();
    const employeeList = this.damageAdministrationService.getEmployees();
    const importerList = this.damageAdministrationService.getImporters();
    const carBrandList = this.damageAdministrationService.getCarBrands();
    const carTypeList = this.damageAdministrationService.getCarTypes();
    const addressList = this.damageAdministrationService.getReceivers();
    const damageTypeList = this.damageAdministrationService.getDamageTypes();
    const damageAreaList = this.damageAdministrationService.getDamageAreas();
    forkJoin([caseIdList, insuranceList, jobTypeList, employeeList, importerList, carBrandList, carTypeList, addressList, damageTypeList, damageAreaList]).subscribe((result: any) => {
      if (result[0].Ok) this.caseIds = result[0].Obj;
      if (result[1].Ok) this.insurances = result[1].Obj;
      if (result[2].Ok) this.jobTypes = result[2].Obj;
      if (result[3].Ok) this.employees = result[3].Obj;
      if (result[4].Ok) {
        this.importers = result[4].Obj;
        result[4].Obj.forEach(c => { c.ImporterName = this.importers.find(i => i.ImporterId === c.ImporterId).ImporterName; });
      }
      if (result[5].Ok) this.brands = result[5].Obj;
      if (result[6].Ok) this.carTypes = result[6].Obj;
      if (result[7].Ok) this.senders = result[7].Obj;
      if (result[7].Ok) this.receivers = result[7].Obj;
      if (result[7].Ok) this.workshops = result[7].Obj;
      if (result[8].Ok) this.damageTypes = result[8].Obj;
      if (result[9].Ok) this.damageAreas = result[9].Obj;
      this.setAutoCompleteFilters();

      this.route.paramMap.subscribe(params => {
        const idParam = params.get('id');
        if (idParam) {
          this.damageCase.Id = Number(idParam);
          const event = new Event();
          event.isUserInput = true;
          this.onCaseIdSelectionChange(this.damageCase.Id, event);
        } else {
          this.initData();
        }
      });
    });
  }

  public getDamageAreaDescription(id: number): string {
    return this.damageAreas.find(o => o.Id === id)?.DescriptionDE;
  }

  public getDamageTypeDescription(id: number): string {
    return this.damageTypes.find(o => o.Id === id)?.DescriptionDE;
  }

  public initData() {
    this.damageCase.Id = 0;
    this.tempDamageDate = null;
    this.tempCaseEndDate = null;
    this.tempReimbursementDate = null;
    this.damageCase.ReportedByCustomer = false;
    this.damageCase.DamageDate = '';
    this.damageCase.CaseEnd = '';
    this.damageCase.Reimbursement = '';
    this.damageCase.DamageTime = '';
    this.damageCase.InsuranceId = 0;
    this.insuranceControl.reset();
    this.damageCase.JobTypeId = 0;
    this.jobTypeControl.reset();
    this.damageCase.CausedById = 0;
    this.employeeControl.reset();
    this.damageCase.SenderId = 0;
    this.senderControl.reset();
    this.damageCase.WorkshopId = 0;
    this.workshopControl.reset();
    this.damageCase.BrandId = 0;
    this.brandControl.reset();
    this.damageCase.CarTypeId = 0;
    this.carTypeControl.reset();
    this.damageCase.ImporterId = 0;
    this.importerControl.reset();
    this.damageCase.ReceiverId = 0;
    this.receiverControl.reset();
    this.damageCase.TransitId = 0;
    this.damageCase.PolicyNo = '';
    this.damageCase.Identification = '';
    this.damageCase.License = '';
    this.damageCase.ChassisNo = '';
    this.damageCase.CostEstimate = null;
    this.damageCase.DamageAmount = null;
    this.damageCase.InsuranceAmount = null;
    this.damageCase.OwnCosts = null;
    this.damageCase.Comment = '';
    this.damageCase.InsuranceComment = '';
    this.damageCase.Guilty = false;
    this.damageCase.InternalState = null;
    this.damageCase.ExternalState = 0;
    this.damageCase.FeedState = 0;
    this.damageCase.Damages = [];
    this.damageCase.DamageDocuments = [];
    this.damageCase.Feeds = [];
  }

  /* Date and TimePicker */

  openDamageDatePicker(damagePicker: MatDatepicker<Date>) {
    damagePicker.open();
    setTimeout(() => this.damageDateInput.nativeElement.focus());
  }
  openCaseEndDatePicker(caseEndPicker: MatDatepicker<Date>) {
    caseEndPicker.open();
    setTimeout(() => this.caseEndDateInput.nativeElement.focus());
  }
  openReimbursementDatePicker(reimbursementPicker: MatDatepicker<Date>) {
    reimbursementPicker.open();
    setTimeout(() => this.reimbursementDateInput.nativeElement.focus());
  }
  changeTime($event: Event) {
    // @ts-ignore
    this.damageCase.DamageTime = $event.target.value;
  }

  /* AutoCompletes and Filters */

  private setAutoCompleteFilters() {
    this.filteredCaseIds = this.caseIdControl.valueChanges.pipe(startWith(null), map(value => this.filterCaseIds(value)));
    this.filteredInsurances = this.insuranceControl.valueChanges.pipe(startWith(null), map(value => this.filterInsurance(value)));
    this.filteredJobTypes = this.jobTypeControl.valueChanges.pipe(startWith(null), map(value => this.filterJobType(value)));
    this.filteredEmployees = this.employeeControl.valueChanges.pipe(startWith(null), map(value => this.filterEmployee(value)));
    this.filteredSenders = this.senderControl.valueChanges.pipe(startWith(null), map(value => this.filterSender(value)));
    this.filteredReceivers = this.receiverControl.valueChanges.pipe(startWith(null), map(value => this.filterReceiver(value)));
    this.filteredWorkshops = this.workshopControl.valueChanges.pipe(startWith(null), map(value => this.filterWorkshop(value)));
    this.filteredBrands = this.brandControl.valueChanges.pipe(startWith(null), map(value => this.filterBrand(value)));
    this.filteredCarTypes = this.carTypeControl.valueChanges.pipe(startWith(null), map(value => this.filterCarType(value)));
    this.filteredImporters = this.importerControl.valueChanges.pipe(startWith(null), map(value => this.filterImporter(value)));
    this.filteredDamageTypes = this.damageTypeControl.valueChanges.pipe(startWith(null), map(value => this.filterDamageType(value)));
    this.filteredDamageAreas = this.damageAreaControl.valueChanges.pipe(startWith(null), map(value => this.filterDamageArea(value)));
  }
  private resetSearchCaseIdInput() {
    this.filteredCaseIds = this.caseIdControl.valueChanges.pipe(startWith(''), map(value => this.filterCaseIds(value)));
  }
  private filterCaseIds(value: string | string | null): number[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value ?? '';
    return this.caseIds.filter(item => item.toString().includes(filterValue));
  }
  private filterInsurance(value: Insurance | string | null): Insurance[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.InsuranceName.toLowerCase() ?? '';
    return this.insurances.filter(i => i.InsuranceName.toLowerCase().includes(filterValue));
  }
  private filterJobType(value: JobType | string | null): JobType[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.JobTypeName.toLowerCase() ?? '';
    return this.jobTypes.filter(i => i.JobTypeName.toLowerCase().includes(filterValue));
  }
  private filterEmployee(value: Employee | string | null): Employee[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.LastName.toLowerCase() ?? '';
    return this.employees.filter(i => i.LastName.toLowerCase().includes(filterValue));
  }
  private filterSender(value: Receiver | string | null): Receiver[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.ReceiverName.toLowerCase() ?? '';
    return this.senders.filter(i => i.ReceiverName.toLowerCase().includes(filterValue));
  }
  private filterReceiver(value: Receiver | string | null): Receiver[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.ReceiverName.toLowerCase() ?? '';
    return this.receivers.filter(i => i.ReceiverName.toLowerCase().includes(filterValue));
  }
  private filterWorkshop(value: Receiver | string | null): Receiver[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.ReceiverName.toLowerCase() ?? '';
    return this.workshops.filter(i => i.ReceiverName.toLowerCase().includes(filterValue));
  }
  private filterBrand(value: CarBrand | string | null): CarBrand[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.CarBrandName.toLowerCase() ?? '';
    return this.brands.filter(i => i.CarBrandName.toLowerCase().includes(filterValue));
  }
  private filterCarType(value: CarType | string | null): CarType[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.CarTypeName.toLowerCase() ?? '';
    return this.carTypes.filter(i => i.CarTypeName.toLowerCase().includes(filterValue));
  }
  private filterImporter(value: Importer | string | null): Importer[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.ImporterName.toLowerCase() ?? '';
    return this.importers.filter(i => i.ImporterName.toLowerCase().includes(filterValue));
  }
  private filterDamageType(value: DamageType | string | null): DamageType[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.DescriptionDE.toLowerCase() ?? '';
    return this.damageTypes.filter(i => i.DescriptionDE.toLowerCase().includes(filterValue));
  }
  private filterDamageArea(value: DamageArea | string | null): DamageArea[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.DescriptionDE.toLowerCase() ?? '';
    return this.damageAreas.filter(i => i.DescriptionDE.toLowerCase().includes(filterValue));
  }

  /* BusinessLogic for ValueChanges on Selects */

  onInsuranceSelectionChange(insurance: Insurance) {
    this.damageCase.PolicyNo = insurance.PoliceNo;
  }

  /* DamageCase */

  onCaseIdSelectionChange(id: number, e: Event) {
    if (id === 0 || !e.isUserInput) { return; }
    this.damageAdministrationService.getDamageCaseById(id).subscribe(response => {
      if (response.Ok) {
        // Fill Select-DisplayNames
        this.updateFrontEndDamageCase(response.Obj);
        // Fill dates
        let d;
        if (response.Obj.DamageDate !== '') {
          d = response.Obj.DamageDate.split('.');
          this.tempDamageDate = new Date(+d[2], +(d[1] - 1), +d[0]);
        } else { this.tempDamageDate = null; }
        if (response.Obj.CaseEnd !== '') {
          d = response.Obj.CaseEnd.split('.');
          this.tempCaseEndDate = new Date(+d[2], +(d[1] - 1), +d[0]);
        } else { this.tempCaseEndDate = null; }
        if (response.Obj.Reimbursement !== '') {
          d = response.Obj.Reimbursement.split('.');
          this.tempReimbursementDate = new Date(+d[2], +(d[1] - 1), +d[0]);
        } else { this.tempReimbursementDate = null; }
        this.searchElement.nativeElement.value = '';
        this.caseId.nativeElement.focus();
        this.resetSearchCaseIdInput();
        this.cancelDamage();
        this.cancelDocument();
        if (response.Obj.FeedState === 2) this.resetFeedState();
      }
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire(response.Ok ? this.translation.Success : this.translation.Error, response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire(this.translation.Error, this.translation.InternalServerError, 'error');
    };
  }
  saveDamageCase() {
    /* Prepare Data */
    this.damageCase.UserId = +sessionStorage.getItem('UserId');
    this.damageCase.DamageDate = this.datepipe.transform(this.tempDamageDate, 'dd.MM.yyyy');
    this.damageCase.CaseEnd = this.tempReimbursementDate !== null ? this.datepipe.transform(this.tempCaseEndDate, 'dd.MM.yyyy') : '';
    this.damageCase.Reimbursement = this.tempReimbursementDate !== null ? this.datepipe.transform(this.tempReimbursementDate, 'dd.MM.yyyy') : '';
    this.damageCase.InsuranceId = this.insuranceControl.value?.InsuranceId ?? null;
    this.damageCase.JobTypeId = this.jobTypeControl.value?.JobTypeId ?? null;
    this.damageCase.CausedById = this.employeeControl.value?.UniqueId ?? null;
    this.damageCase.SenderId = this.senderControl.value?.ReceiverId ?? null;
    this.damageCase.ReceiverId = this.receiverControl.value?.ReceiverId ?? null;
    this.damageCase.SenderId = this.senderControl.value?.ReceiverId ?? null;
    this.damageCase.WorkshopId = this.workshopControl.value?.ReceiverId ?? null;
    this.damageCase.BrandId = this.brandControl.value?.CarBrandId ?? null;
    this.damageCase.CarTypeId = this.carTypeControl.value?.CarTypeId ?? null;
    this.damageCase.ImporterId = this.importerControl.value?.ImporterId ?? null;

    if (this.validateDamageCase()) {
      if (this.damageCase.Id === 0) {
        this.insertDamageCase();
      } else {
        this.updateDamageCase();
      }
    }
  }
  insertDamageCase() {
    this.damageAdministrationService.insertDamageCase(this.damageCase).subscribe(response => {
      if (response.Ok) {
        this.updateFrontEndDamageCase(response.Obj);
        this.toast.fire('Erfolg', 'Schadenfall wurde erfolgreich erstellt.', 'success');
        this.caseIds.unshift(this.damageCase.Id);
        this.resetSearchCaseIdInput();
        return;
      }
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire(response.Ok ? this.translation.Success : this.translation.Error, response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire(this.translation.Error, this.translation.InternalServerError, 'error');
    };
  }
  updateDamageCase() {
    this.damageAdministrationService.updateDamageCaseByCotra(this.damageCase).subscribe(response => {
      if (response.Ok) {
        this.toast.fire('Erfolg', 'Schadenfall wurde erfolgreich gespeichert.', 'success');
        this.updateFrontEndDamageCase(response.Obj);
      } else {
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire(response.Ok ? this.translation.Success : this.translation.Error, response.Msg, response.Ok ? 'success' : 'error');
      }
    }), (error: any) => {
      console.log(error);
      this.toast.fire(this.translation.Error, this.translation.InternalServerError, 'error');
    };
  }
  deleteDamageCasePopup() {
    if (this.damageCase.Id === 0) { return; }
    Swal.fire({
      title: 'Löschen?',
      text: 'Möchten Sie diesen Schadenfall wirklich löschen: Schadenfallnummer: ' + this.damageCase.Id + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Löschen',
      cancelButtonText: 'Abbrechen',
    }).then((result) => {
      if (result.value) {
        this.deleteDamageCase();
      }
    });
  }
  deleteDamageCase() {
    this.damageAdministrationService.deleteDamageCase(this.damageCase.Id).subscribe(response => {
      if (response.Ok && response.Obj) {
        Swal.fire('Erfolg', 'Schadenfall wurde erfolgreich gelöscht.', 'success');
        this.caseIds = this.caseIds.filter(id => id !== this.damageCase.Id);
        this.caseIdControl.setValue(this.caseIdControl.value);
        this.initData();
      } else {
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire(response.Ok ? this.translation.Success : this.translation.Error, response.Msg, response.Ok ? 'success' : 'error');
      }
    }), (error: any) => {
      console.log(error);
      this.toast.fire(this.translation.Error, this.translation.InternalServerError, 'error');
    };
  }
  validateDamageCase() {
    if (this.damageCase.InsuranceId === 0 || this.damageCase.InsuranceId === null) {
      this.toast.fire('Fehler', 'Versicherungsart darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.JobTypeId === 0 || this.damageCase.JobTypeId === null) {
      this.toast.fire('Fehler', 'Auftragstyp darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.CausedById === 0 || this.damageCase.CausedById === null) {
      this.toast.fire('Fehler', 'Verursacher darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.SenderId === 0 || this.damageCase.SenderId === null) {
      this.toast.fire('Fehler', 'Absender darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.ReceiverId === 0 || this.damageCase.ReceiverId === null) {
      this.toast.fire('Fehler', 'Empfänger darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.WorkshopId === 0 || this.damageCase.WorkshopId === null) {
      this.toast.fire('Fehler', 'Reparaturwerkstatt darf nicht leer sein. Falls sie noch nicht bekannt ist, geben Sie Unbekannt an.', 'error');
      return false;
    }
    if (this.damageCase.BrandId === 0 || this.damageCase.BrandId === null) {
      this.toast.fire('Fehler', 'Marke darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.ImporterId === 0 || this.damageCase.ImporterId === null) {
      this.toast.fire('Fehler', 'Importeur darf nicht leer sein.', 'error');
      return false;
    }
    if ((this.damageCase.ChassisNo === '' || this.damageCase.ChassisNo === null) &&
      (this.damageCase.License === '' || this.damageCase.License === null) &&
      (this.damageCase.Identification === '' || this.damageCase.Identification === null)) {
      this.toast.fire('Fehler', 'Es muss zumindest die Chassis-Nummer, das Kennzeichen oder die Referenz ausgefüllt sein.', 'error');
      return false;
    }
    if (this.damageCase.ChassisNo !== '' && this.damageCase.ChassisNo.length !== 17) {
      this.toast.fire('Fehler', 'Die Chassis-Nummer muss 17 Zeichen lang sein.', 'error');
      return false;
    }
    if (!this.damageCase.InternalState === null) {
      this.toast.fire('Fehler', 'Ein Status muss ausgewählt sein.', 'error');
      return false;
    }
    if (this.damageCase.InternalState >= 3 && this.damageCase.AccountAssignment === null) {
      this.toast.fire('Fehler', 'Kontierung darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.CostEstimate < 2000 && this.damageCase.InternalState === 9 && (this.damageCase.CaseEnd === '' || this.damageCase.CaseEnd === null || this.damageCase.CaseEnd === undefined)) {
      this.toast.fire('Fehler', 'Rückvergütungsdatum darf nicht leer sein.', 'error');
      return false;
    }
    if (this.damageCase.InternalState >= 7 && (this.damageCase.DamageAmount === 0 || this.damageCase.DamageAmount === null)) {
      this.toast.fire('Fehler', 'Schadenbetrag darf nicht leer sein.', 'error');
      return false;
    }
    if (!this.damageCase.Damages === null) {
      if (this.damageCase.Damages.length === 0) {
        this.toast.fire('Fehler', 'Es muss mindestens ein Schaden erfasst werden.', 'error');
        return false;
      }
    }
    return true;
  }
  updateFrontEndDamageCase(dmgCase: DamageCase) {
    this.damageCase = dmgCase;
    if (this.damageCase.Feeds != null) this.damageCase.Feeds.sort((a, b) => new Date(b.TimeStamp).getTime() - new Date(a.TimeStamp).getTime());
    this.employeeControl.setValue(this.employees.find(i => i.UniqueId === this.damageCase.CausedById));
    this.importerControl.setValue(this.importers.find(i => i.ImporterId === this.damageCase.ImporterId));
    this.insuranceControl.setValue(this.insurances.find(i => i.InsuranceId === this.damageCase.InsuranceId) ?? null);
    this.jobTypeControl.setValue(this.jobTypes.find(i => i.JobTypeId === this.damageCase.JobTypeId));
    this.receiverControl.setValue(this.receivers.find(i => i.ReceiverId === this.damageCase.ReceiverId));
    this.senderControl.setValue(this.senders.find(i => i.ReceiverId === this.damageCase.SenderId));
    this.workshopControl.setValue(this.workshops.find(i => i.ReceiverId === this.damageCase.WorkshopId));
    this.brandControl.setValue(this.brands.find(i => i.CarBrandId === this.damageCase.BrandId));
    this.carTypeControl.setValue(this.carTypes.find(i => i.CarTypeId === this.damageCase.CarTypeId));
  }

  /* Damages */

  createNewDamage() {
    this.damageInEdit = {
      CaseId: null,
      AreaId: null,
      TypeId: null,
      Images: [],
      TempId: crypto.randomUUID(),
      InEdit: true
    } as Damage;
  }
  removeDamage() {
    if (this.damageInEdit.Id > 0) {
      this.damageCase.Damages = this.damageCase.Damages.filter(d => d.Id !== this.damageInEdit.Id);
    } else {
      this.damageCase.Damages = this.damageCase.Damages.filter(d => d.TempId !== this.damageInEdit.TempId);
    }
    this.cancelDamage();
  }
  editDamage(damage: Damage) {
    this.damageInEdit = structuredClone(damage);
    this.damageAreaControl.setValue(this.damageAreas.find(o => o.Id === damage.AreaId) ?? null);
    this.damageTypeControl.setValue(this.damageTypes.find(o => o.Id === damage.TypeId) ?? null);
    this.damageInEdit.InEdit = true;
    this.documentInEdit.InEdit = false;
  }
  saveDamage() {
    this.damageInEdit.AreaId = this.damageAreaControl.value?.Code ?? null;
    this.damageInEdit.TypeId = this.damageTypeControl.value?.Code ?? null;
    if (!this.validateDamage()) return;
    const damages = this.damageCase.Damages;

    const index = damages.findIndex(d => d.Id > 0 && this.damageInEdit.Id > 0 ? d.Id === this.damageInEdit.Id : d.TempId === this.damageInEdit.TempId);

    if (index === -1) {
      damages.push({ ...this.damageInEdit });
    } else {
      damages[index] = { ...this.damageInEdit };
    }
  
    this.cancelDamage();
  }
  cancelDamage() {
    this.damageInEdit = new Damage();
    this.damageInEdit.InEdit = false;
  }
  isExistingDamage(): boolean {
  if (!this.damageInEdit) return false;

    return this.damageCase.Damages.some(d =>
      (d.Id > 0 && d.Id === this.damageInEdit.Id) ||
      (d.TempId && d.TempId === this.damageInEdit.TempId)
    );
  }
  validateDamage() {
    if (this.damageInEdit.AreaId == null) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoArea, '', 'error');
      return false;
    }
    if (this.damageInEdit.TypeId == null) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoType, '', 'error');
      return false;
    }
    if (this.damageInEdit.Images.length == 0) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoImage, '', 'error');
      return false;
    }
    return true;
  }
  onDamageFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    if (input.files.length > 0) {
      const files = Array.from(input.files);

      files.forEach(file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          const damageImage = new DamageImage();
          damageImage.Base64 = reader.result as string;
          if (!this.IsImage(damageImage.Base64)) {
            this.toast.fire(this.translation.AddImageErrorMessage, '', 'error');
            return;
          }
          damageImage.FileName = file.name;
          this.damageInEdit.Images.push(damageImage);
        };
      });
    }
  }
  requestAdditionalFotosPopup(damage: Damage) {
    Swal.fire({
      title: 'Weitere Fotos anfordern',
      icon: 'info',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: 'Ergänzen',
      denyButtonText: 'Ersetzen',
      cancelButtonText: 'Abbrechen',
      confirmButtonColor: '#CC0000',
      denyButtonColor: '#CC0000',
      html: `
      <p>Sollen die neuen Fotos die alten Fotos ersetzen oder ergänzen?</p>
      <div style="margin-top:10px;">
        <label>
          <input type="checkbox" id="moreFotosCheckbox" checked style="accent-color:#CC0000; cursor:pointer;"/>
          Mehr als 4 Fotos erlauben
        </label>
      </div>
      `,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) return;
      damage.AdditionalFotosRequested = true;
      damage.AllowMoreThanFour = (document.getElementById('moreFotosCheckbox') as HTMLInputElement)?.checked ?? true;
      this.requestAdditionalFotos(damage, result.isConfirmed ? "Ergänzen" : "Ersetzen");
    });
  }
  requestAdditionalFotos(damage: Damage, option: string) {
    this.damageAdministrationService.requestAdditionalFotos(damage, option).subscribe(response => {
      if (response.Ok) {
        this.damageCase = response.Obj;
        this.toast.fire(this.translation.Success, 'Zusätzliche Fotos angefordert', 'success');
      } else {
        if (response.Ex) console.log(response.Ex);
        if (response.Msg) this.toast.fire(response.Ok ? this.translation.Success : this.translation.Error, response.Msg, response.Ok ? 'success' : 'error');
      }
    }), (error: any) => {
      console.log(error);
      this.toast.fire(this.translation.Error, this.translation.InternalServerError, 'error');
    };
  }
  removeImage(index: number) {
    this.damageInEdit.Images.splice(index, 1);
  }

  /* Documents */

  createNewDocument() {
    this.documentInEdit = {
      DocumentType: null,
      FileName: null,
      InEdit: true,
      TempId: crypto.randomUUID(),
    } as DamageDocument;
  }
  removeDocument() {
    if (this.documentInEdit.Id > 0) {
      this.damageCase.DamageDocuments = this.damageCase.DamageDocuments.filter(d => d.Id !== this.documentInEdit.Id);
    } else {
      this.damageCase.DamageDocuments = this.damageCase.DamageDocuments.filter(d => d.TempId !== this.documentInEdit.TempId);
    }
    this.cancelDocument();
  }
  editDocument(document: DamageDocument) {
    this.documentInEdit = { ...document };
    this.documentInEdit.InEdit = true;
    this.damageInEdit.InEdit = false;
  }
  saveDocument() {
    if (!this.validateDocument()) return;
    const documents = this.damageCase.DamageDocuments;

    const index = documents.findIndex(d => d.Id > 0 && this.documentInEdit.Id > 0 ? d.Id === this.documentInEdit.Id : d.TempId === this.documentInEdit.TempId);

    if (index === -1) {
      documents.push({ ...this.documentInEdit });
    } else {
      documents[index] = { ...this.documentInEdit };
    }
  
    this.cancelDocument();
  }
  cancelDocument() {
    this.documentInEdit = new DamageDocument();
    this.documentInEdit.InEdit = false;
  }
  isExistingDocument(): boolean {
    if (!this.documentInEdit) return false;

    return this.damageCase.DamageDocuments.some(d =>
      (d.Id > 0 && d.Id === this.documentInEdit.Id) ||
      (d.TempId && d.TempId === this.documentInEdit.TempId)
    );
  }
  validateDocument() {
    if (this.documentInEdit.DocumentType == null) {
      this.toast.fire('Bitte geben Sie den Dokument-Typ an.', '', 'warning');
      return false;
    }
    if (this.documentInEdit.FileName == null) {
      this.toast.fire('Bitte wählen Sie eine Datei aus.', '', 'warning');
      return false;
    }
    return true;
  }
  onDocumentFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = Array.from(input.files)[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.documentInEdit.Base64 = reader.result as string;
      this.documentInEdit.FileName = file.name;
      if (this.documentInEdit.DocumentType == null || this.documentInEdit.DocumentType == '') {
        this.documentInEdit.DocumentType = '4';
      }
    };
  }

  /* Helpers */

  public displayWithText(type: string) {
    switch (type) {
      case 'receiver': return (s: Receiver | null) => s?.ReceiverName ?? '';
      case 'carBrand': return (s: CarBrand | null) => s?.CarBrandName ?? '';
      case 'carType': return (s: CarType | null) => s?.CarTypeName ?? '';
      case 'importer': return (s: Importer | null) => s?.ImporterName ?? '';
      case 'insurance': return (s: Insurance | null) => s?.InsuranceName ?? '';
      case 'jobType': return (s: JobType | null) => s?.JobTypeName ?? '';
      case 'causedBy': return (s: Employee | null) => s?.LastName ?? '';
      case 'damageArea': return (s: DamageArea | null) => s?.DescriptionDE ?? '';
      case 'damageType': return (s: DamageType | null) => s?.DescriptionDE ?? '';
    }
  }

  calculateOwnCosts() {
    if (this.damageCase.DamageAmount !== null && this.damageCase.InsuranceAmount !== null) {
      this.damageCase.OwnCosts = this.damageCase.DamageAmount - this.damageCase.InsuranceAmount;
    }
  }

  onPreviewClick(dataUrl: string, filename: string) {
    const mimeType = dataUrl.match(/^data:(.*);base64,/)?.[1] ?? '';

    let body = '';

    if (mimeType.startsWith('image/')) {
      body = `<img src="${dataUrl}" style="max-width:100%;height:auto;" />`;
    } else if (mimeType === 'application/pdf') {
      body = `<embed src="${dataUrl}" type="application/pdf" width="100%" height="100%" />`;
    } else {
      return;
    }

    const html = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${filename}</title>
          <style>
            body {
              margin: 0;
              background: #111;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
            }
          </style>
        </head>
        <body>
          ${body}
        </body>
      </html>
    `;

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');
  }

  IsImage(base64: string): boolean {
    return base64?.trim().startsWith('data:image');
  }

  saveFeed() {
    if (this.feedHtmlString === '' || this.feedHtmlString.trim() === '') return;
    const newFeed = new Feed();
    newFeed.CaseId = this.damageCase.Id;
    newFeed.ContentHtml = this.feedHtmlString;
    newFeed.ExternalSender = false;
    newFeed.SenderName = this.userName;
    newFeed.TimeStamp = new Date();
    this.damageAdministrationService.insertFeed(newFeed).subscribe(response => {
      if (response.Ok) {
        this.damageCase.Feeds.unshift(response.Obj);
        this.feedHtmlString = '';
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError, '', 'error'); });
  }

  resetFeedState() {
    this.damageAdministrationService.resetFeedStateByCaseId(this.damageCase.Id).subscribe(response => {

    }, error => { });
  }
}
